(function () {
  if (window.MMCart && typeof window.MMCart.add === 'function') return;

  function cartRoute(name, fallback) {
    return window.Theme && window.Theme.routes && window.Theme.routes[name] ? window.Theme.routes[name] : fallback;
  }

  function cartJsonUrl() {
    var cartUrl = cartRoute('cart_url', '/cart');
    return cartUrl.indexOf('.js') > -1 ? cartUrl : cartUrl.replace(/\/$/, '') + '.js';
  }

  function cartSectionIds() {
    return Array.prototype.slice.call(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(function (el) { return el.getAttribute('data-section-id'); })
      .filter(Boolean);
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      requestAnimationFrame(function () { drawer.open(); });
    }
  }

  function dispatchCartUpdate(args) {
    var quantity = Number(args.quantity || 1);
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: args.cart || args.addData || {},
        sourceId: args.sourceId || 'mm-cart-helper',
        data: {
          source: 'product-form-component',
          itemCount: quantity,
          productId: args.productId ? String(args.productId) : undefined,
          variantId: args.variantId ? String(args.variantId) : undefined,
          sections: args.sections || args.addData && args.addData.sections || {}
        }
      }
    }));
  }

  function dispatchCartError(error, args) {
    document.dispatchEvent(new CustomEvent('cart:error', {
      bubbles: true,
      detail: {
        sourceId: args && args.sourceId || 'mm-cart-helper',
        error: error,
        variantId: args && args.variantId
      }
    }));
  }

  async function fetchCart() {
    try {
      var response = await fetch(cartJsonUrl(), { headers: { Accept: 'application/json' } });
      return response.ok ? response.json() : null;
    } catch (error) {
      return null;
    }
  }

  async function add(input) {
    var args = typeof input === 'object' ? input : { id: input };
    var variantId = Number(args.id || args.variantId);
    var quantity = Math.max(1, Number(args.quantity || 1));
    if (!variantId) throw new Error('Missing variant id');

    var sectionIds = cartSectionIds();
    var body = { items: [{ id: variantId, quantity: quantity }] };
    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }

    try {
      var response = await fetch(cartRoute('cart_add_url', '/cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      });
      var addData = await response.json().catch(function () { return {}; });
      if (!response.ok || addData.status || addData.errors) {
        throw new Error(addData.description || addData.message || 'Cart add failed');
      }

      // The Section Rendering response already contains the authoritative cart HTML
      // and item count. Only fall back to /cart.js when Shopify omits that payload.
      var hasSections = addData.sections && Object.keys(addData.sections).length > 0;
      var cart = hasSections ? null : await fetchCart();
      dispatchCartUpdate({
        addData: addData,
        cart: cart,
        quantity: quantity,
        productId: args.productId,
        sourceId: args.sourceId,
        variantId: variantId
      });
      if (args.openDrawer !== false) openDrawer();
      return { addData: addData, cart: cart };
    } catch (error) {
      dispatchCartError(error, { sourceId: args.sourceId, variantId: variantId });
      throw error;
    }
  }

  window.MMCart = {
    add: add,
    addVariant: add,
    openDrawer: openDrawer,
    dispatchCartUpdate: dispatchCartUpdate
  };
})();
